module.exports = __webpack_public_path__ + "img/bindclose.5904d803.png";